<template>
	<v-card :elevation="1" class="round-card background-2" width="100%">

		<v-card-title class="px-3 py-2">
			<div class="d-flex align-center">
				<v-icon left>settings_applications</v-icon>
				<span class="headline">Integrazioni</span>
			</div>
			<v-spacer></v-spacer>
			
			<v-text-field 
				class="hidden-xs-only font-weight-regular"
				append-icon="search"
				label="Cerca integrazione"
				v-model="search"
				clearable
				hide-details
				outlined
				dense
			></v-text-field>
		</v-card-title>
		<v-divider></v-divider>

		<v-container class="py-0" fluid>
			<v-row class="ma-0">
				<v-col cols="12" class="hidden-sm-and-up pa-3">
					<v-text-field 
						append-icon="search"
						label="Cerca"
						v-model="search"
						clearable
						hide-details
						outlined
						dense
					></v-text-field>
				</v-col>
			</v-row>
		</v-container>

		<v-data-iterator
		:items="filteredApps"
		:options.sync="pagination"
		item-key="id"
		hide-default-footer
		content-tag="v-row"
		class="background-2"
		>
      	<template v-slot:default="props">
			<v-row class="ma-0">
				<v-col class="pa-4 col-xl-2 col-lg-3 col-md-3 col-sm-4" v-for="item in props.items" :key="item.id">
					<v-hover>
						<v-card
							@click="$router.push({ path: '/settingsgeneral/integrations/' + item.key + '/' + item.id, params: { id: item.id }})"
							slot-scope="{ hover }"
							:class="`elevation-${hover ? 10 : 1}`"
							class="pt-4 mx-auto cursor-pointer background-1 round-card"
							text
							>
							<v-card-text class="text-center">
								<v-avatar tile size="88">
									<img :src="'img/integrations/' + item.logo" :alt="item.name" style="border-radius: 50%;">
								</v-avatar>
								<h3 class="headline mb-1">
									{{ item.name }}
								</h3>
								<div class="mb-1">Stato</div>
								<div v-if="item.active" class="subheader font-weight-bold" style="display: inline-flex;">Attivo<v-icon color="success" class="fs14i pl-2">fiber_manual_record</v-icon></div>
								<div v-else class="subheader font-weight-bold" style="display: inline-flex;">Disattivo<v-icon color="error" class="fs14i pl-2">fiber_manual_record</v-icon></div>
							</v-card-text>
						</v-card>
					</v-hover>
				</v-col>
			</v-row>
		</template>

		<template v-slot:no-data>
			<v-row class="ma-0">
				<v-col v-if="search" cols="12" class="text-center py-12">
					<div class="empty-state-container">
						<v-avatar class="empty-state-icon mb-6" size="120" color="primary" style="background: linear-gradient(45deg, #2196F3, #21CBF3);">
							<v-icon size="60" color="white">search_off</v-icon>
						</v-avatar>
						
						<h2 class="display-1 font-weight-light mb-3" style="color: #424242;">
							Nessun risultato trovato
						</h2>
						
						<p class="subtitle-1 grey--text mb-6" style="max-width: 400px; margin: 0 auto;">
							Non abbiamo trovato integrazioni che corrispondano a 
							<strong class="primary--text">"{{ search }}"</strong>
						</p>
						
						<div class="d-flex justify-center flex-wrap gap-3">
							<v-btn 
								@click="search = ''" 
								color="primary" 
								outlined 
								rounded
								class="mx-2"
							>
								<v-icon left>clear</v-icon>
								Cancella ricerca
							</v-btn>
							
							<v-btn 
								@click="search = 'mef'" 
								color="success" 
								outlined 
								rounded
								class="mx-2"
							>
								<v-icon left>search</v-icon>
								Cerca "MEF"
							</v-btn>
						</div>
						
						<v-divider class="my-6" style="max-width: 200px; margin: 24px auto;"></v-divider>
						
						<div class="d-flex justify-center align-center">
							<v-icon class="mr-2" color="info">lightbulb_outline</v-icon>
							<span class="caption info--text">
								Suggerimento: prova termini più generici come "sync", "import" o "api"
							</span>
						</div>
					</div>
				</v-col>
				
				<!-- Empty state quando non ci sono integrazioni disponibili -->
				<v-col v-else cols="12" class="text-center py-12">
					<div class="empty-state-container">
						<v-avatar class="empty-state-icon mb-6" size="120" color="grey" style="background: linear-gradient(45deg, #757575, #9E9E9E);">
							<v-icon size="60" color="white">extension</v-icon>
						</v-avatar>
						
						<h2 class="display-1 font-weight-light mb-3" style="color: #424242;">
							Nessuna integrazione disponibile
						</h2>
						
						<p class="subtitle-1 grey--text mb-6" style="max-width: 400px; margin: 0 auto;">
							Al momento non sono configurate integrazioni nel sistema
						</p>
					</div>
				</v-col>
			</v-row>
		</template>

			<template v-slot:footer="{ pagination, updateOptions }">
				<v-divider class="mx-4"></v-divider>
				<v-data-footer
					:pagination="pagination"
					:options="pagination"
					@update:options="updateOptions"
					:items-per-page-options="[8, 16, 24, { text: 'Tutti', value: -1 }]"
					show-first-last-page
				>
					<template v-slot:page-text="{ pageStart, pageStop, itemsLength }">
						Da {{ pageStart }} a {{ pageStop }} di {{ itemsLength }}
					</template>
				</v-data-footer>
			</template>
		</v-data-iterator>
	</v-card>
</template>

<script>
	export default {
		name:'settings-integrations-apps',
		props: {},
		data() {
			return {
				apps: [],
				search: '',
				pagination: {
					itemsPerPage: 8
				}
			}
		},

		computed: {
			filteredApps() {
				if (!this.search || this.search.trim() === '') {
					return this.apps
				}
				
				const searchTerm = this.search.toLowerCase().trim()
				return this.apps.filter(app => {
					return app.name.toLowerCase().includes(searchTerm) ||
						   app.key.toLowerCase().includes(searchTerm) ||
						   (app.type && app.type.toLowerCase().includes(searchTerm))
				})
			}
		},

		created() {
			this.axios.post('integrationsapps-filters').then(response => {
			    // get body data
			   	this.apps = response.data.data.data
			   	this.$store.commit('endProgress')

			}, response => {
			    // error callback
			})
		}
	}
</script>

<style>
.empty-state-container {
	animation: fadeInUp 0.6s ease-out;
}

.empty-state-icon {
	animation: bounceIn 0.8s ease-out;
	box-shadow: 0 8px 32px rgba(33, 150, 243, 0.3);
}

@keyframes fadeInUp {
	from {
		opacity: 0;
		transform: translateY(30px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}

@keyframes bounceIn {
	0%, 20%, 40%, 60%, 80% {
		animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
	}
	0% {
		opacity: 0;
		transform: scale3d(.3, .3, .3);
	}
	20% {
		transform: scale3d(1.1, 1.1, 1.1);
	}
	40% {
		transform: scale3d(.9, .9, .9);
	}
	60% {
		opacity: 1;
		transform: scale3d(1.03, 1.03, 1.03);
	}
	80% {
		transform: scale3d(.97, .97, .97);
	}
	to {
		opacity: 1;
		transform: scale3d(1, 1, 1);
	}
}

.v-btn {
	transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.v-btn:hover {
	transform: translateY(-2px);
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
</style>
